import * as React from 'react';
import { ITag } from 'src/tag/tag.models';
import './TagView.scss';
import { ComponentType } from '@gcl/react-core';
import { DisplayWrapper } from '@core/DisplayWrapper/DisplayWrapper';
import { TagItemView } from './TagItemView';
import { AddTagBtn } from './AddTagBtn';

export type RenderTagContentFn = (item: ITag | undefined) => React.ReactElement;

export interface ITagViewItem extends ITag {
  onRenderTagContent?: RenderTagContentFn;
  disableRemove?: boolean;
  componentType?: ComponentType;
}

export interface ITagViewProps {
  tags: ITagViewItem[];
  isLoading?: boolean;
  error?: Error | null;
  disabled?: boolean;
  onAdd?: (newTag: ITagViewItem) => void;
  onRemove?: (index: number) => void;
}

export const TagView: React.FunctionComponent<ITagViewProps> = ({
  tags,
  isLoading = false,
  error,
  disabled = false,
  onAdd = () => {},
  onRemove = () => {},
}) => {
  return (
    <DisplayWrapper isLoading={isLoading} error={error?.message}>
      <div className="gcl-gems-tag-container">
        {tags.map((tag, index) => {
          return (
            <TagItemView
              tag={tag}
              key={`tag-${tag.id}-${index.toString()}`}
              onRemove={disabled || tag.disableRemove ? undefined : onRemove}
              index={index}
              onRenderTagContent={tag.onRenderTagContent}
              componentType={tag.componentType}
            />
          );
        })}
        {disabled ? undefined : (
          <AddTagBtn onAdd={onAdd} className="gcl-mr-sm" small={tags && tags.length > 0} existingTags={tags} />
        )}
      </div>
    </DisplayWrapper>
  );
};
